import React from 'react';
import DynamicLegalPage from '../components/DynamicLegalPage';

const CookiesPage: React.FC = () => {
  return <DynamicLegalPage pageType="cookies" />;
};

export default CookiesPage; 